__turbopack_context__.v({
  "className": "inter_8a594245-module__h1XLeG__className",
  "variable": "inter_8a594245-module__h1XLeG__variable",
});
